import { apiPaths } from '@core/http/apiPaths';
import { httpClient } from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ISurvey } from '@models/ISurvey';
import { AxiosResponse } from 'axios';

export const getSurveyMeasurements = createAsyncThunk(
  `${EntityReducers.surveyMeasurements}/getAll`,
  async (accountId: number) => {
    const response: AxiosResponse<ISurvey[]> = await httpClient.get(
      apiPaths.accounts.getSurveyMeasurements({ accountId: accountId.toString() })
    );

    return response.data;
  }
);

export const thunks = {
  getSurveyMeasurements,
};
